module.exports = __webpack_public_path__ + "static/media/didiao002.1106434c.jpg";